import { FC } from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, ButtonBase } from '@mui/material';
import {
  dailyNavStatusNeedsAction,
  getDailyNavReviewState,
} from 'pages/Intelligence/DailyNav/daily-nav.constants';
import { ReviewPriceCellProps } from './ReviewPriceCell.props';

const ReviewPriceCell: FC<ReviewPriceCellProps> = ({ row, onReviewClick, canReview }) => {
  // One resolver for label and colour, so they cannot disagree.
  const reviewState = getDailyNavReviewState(row.record);
  const needsReview = dailyNavStatusNeedsAction(reviewState.status);

  const baseColor = reviewState.color;
  // Read-only buttons stay flat on hover; interactive ones darken.
  const hoverColor = canReview ? reviewState.hoverColor : baseColor;

  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
      <ButtonBase
        id={`review-price-button-${row.companyId}`}
        // Review Price is for firm editors and staff; others get an inert, read-only button.
        disabled={!canReview}
        onClick={canReview ? () => onReviewClick(row) : undefined}
        sx={{
          alignItems: 'center',
          backgroundColor: baseColor,
          borderRadius: '4px',
          color: reviewState.textColor,
          cursor: canReview ? 'pointer' : 'default',
          display: 'inline-flex',
          fontSize: 10,
          fontWeight: 600,
          gap: '4px',
          height: 18,
          lineHeight: 1,
          padding: '2px 8px',
          whiteSpace: 'nowrap',
          '&:hover': {
            backgroundColor: hoverColor,
          },
        }}>
        {/* Only the state asking for action gets the glyph. */}
        {needsReview && <WarningAmberIcon sx={{ fontSize: 11 }} />}
        {reviewState.label}
      </ButtonBase>
    </Box>
  );
};

export default ReviewPriceCell;
